module.exports = __webpack_public_path__ + "static/media/resume.21b71886.pdf";